import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'

export type WindcavePurchaseSessionInputData = {
    type: 'WindcavePurchaseSessionInputData'
    amount: string
    firstName: string
    lastName: string
    phone: string
    email: string
    postalCode: string
}

export type WindcaveTokenizeSessionInputData = {
    type: 'WindcaveTokenizeSessionInputData'
    firstName: string
    lastName: string
    phone: string
    email: string
    postalCode: string
}

export type WindcaveSessionInputData =
    | WindcavePurchaseSessionInputData
    | WindcaveTokenizeSessionInputData

export function useWindcaveQuery() {
    const rpQuery = useRpQuery()

    async function queryWindcaveSession(
        paymentSourceId: string,
        data: WindcaveSessionInputData
    ) {
        if (data.type === 'WindcavePurchaseSessionInputData') {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    query WindcavePurchaseFormQuery(
                        $paymentSourceId: ID!
                        $input: WindcavePurchaseSessionInput!
                    ) {
                        node(id: $paymentSourceId) {
                            __typename
                            ... on PaymentSource {
                                data {
                                    __typename
                                    ... on PaymentSourceCreditCardWindcave {
                                        purchaseSession(input: $input) {
                                            url
                                            supportedCards
                                            sessionId
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    paymentSourceId,
                    input: {
                        ...data,
                        // Wipe out type
                        type: undefined
                    }
                }
            )

            if (
                response.node === null ||
                response.node.__typename !== 'PaymentSource' ||
                response.node.data === null ||
                response.node.data.__typename !==
                    'PaymentSourceCreditCardWindcave'
            ) {
                throw new Error()
            }

            // Save session data
            return response.node.data.purchaseSession
        } else {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    query WindcaveSetupFormQuery(
                        $paymentSourceId: ID!
                        $input: WindcaveTokenizeSessionInput!
                    ) {
                        node(id: $paymentSourceId) {
                            __typename
                            ... on PaymentSource {
                                data {
                                    __typename
                                    ... on PaymentSourceCreditCardWindcave {
                                        tokenizeSession(input: $input) {
                                            url
                                            supportedCards
                                            sessionId
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    paymentSourceId,
                    input: {
                        ...data,
                        // Wipe out type
                        type: undefined
                    }
                }
            )

            if (
                response.node === null ||
                response.node.__typename !== 'PaymentSource' ||
                response.node.data === null ||
                response.node.data.__typename !==
                    'PaymentSourceCreditCardWindcave'
            ) {
                throw new Error()
            }

            // Save session data
            return response.node.data.tokenizeSession
        }
    }

    return {
        queryWindcaveSession
    }
}
